{"FormLabels":{"number":"House number","street":"Street","country":"Country","city":"City","postalCode":"Postal code","Address":"Address"}}